import { Modal, Row, Col, Button } from 'react-bootstrap';
import React, { useEffect } from 'react';
import CardNavigationTab from '~/Components/CardNavigationTab';
import { useState } from 'react';
import ProspectoDetalhes from '~/Components/Prospectos/ProspectoDetalhes/ProspectoDetalhes';
import DetalhesAtivo from './DetalhesAtivo';
import * as api from '~/Services/Service';
import { toast } from 'react-toastify';
import DetalhesEstorno from './DetalhesEstorno';
import DetalhesManutencaoVenda from './DetalhesManutencaoVenda';
import DetalhesPreVendaSemConjuge from './DetalhesPreVendaSemConjuge';
import DetalheCancelamentoDocDigital from './DetalheCancelamentoDocDigital';
import InformacoesJuridicas from '../Juridico/InformacoesJuridicas';
import { FaWindowClose } from 'react-icons/fa';
import AuthStorage from '~/Utils/AuthStorage';
import * as constants from '~/constant';

import DetalhesContraproposta from './DetalhesContraproposta';
import DetalhesCondicaoEspecial from './DetalhesCondicaoEspecial';
import VisualizarTermo from './VisualizarTermo';
import { isAmbienteProducao } from '~/Pages/Vendas/helpers';

const ModalDetalhes = ({ mostrarModal, setMostrarModal, linhaSelecionada }) => {
  const [tab, setTab] = useState('detalhes-pre-venda');
  const [ativo, setAtivo] = useState(null);
  const [etapa, setEtapa] = useState(null);
  const [
    ocorrenciasVendaContraProposta,
    setOcorrenciasVendaContraProposta,
  ] = useState(null);
  const [condicaoEspecial, setCondicaoEspecial] = useState(false);
  const podeAutorizarSemConjuge = AuthStorage.temCaracteristica(242);

  const podeSolicitarCancelamentoDocDigital = AuthStorage.temCaracteristica(
    constants.caracteristicas.DocDigitalSolicitarCanc
  );

  const habilitarCardEstorno = () => {
    if (AuthStorage.temCaracteristica(551)) {
      return true;
    }
    if (AuthStorage.getUser().usuario === linhaSelecionada.codigo_corretor) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await api.buscarContraProposta(
          linhaSelecionada.codigo_proposta
        );
        if (data == null) return;
        const linhas = data.split(/\r\n|\r|\n/);
        setOcorrenciasVendaContraProposta(linhas);
      } catch (error) {
        console.error('Erro ao buscar contraproposta:', error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await api.buscarCondicaoEspecial(
          linhaSelecionada.codigo_proposta
        );
        setCondicaoEspecial(data);
      } catch (error) {
        console.error('Erro ao buscar contraproposta:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const buscarAtivoDetalhes = async () => {
      if (!linhaSelecionada.pre_venda) return;
      try {
        const response = await api.detalharPreVenda(linhaSelecionada.pre_venda);
        if (response) {
          setAtivo(response);
        }
      } catch (error) {
        toast.error(error.message);
      }
    };

    buscarAtivoDetalhes();
  }, []);

  const verificaTab = tab => {
    setTab(tab);
  };

  useEffect(() => {
    const buscarEtapaAtual = async () => {
      try {
        const response = await api.consultarEtapaAtualProspecto(linhaSelecionada.codigo_prospecto);
        if (response) {
          setEtapa(response);
        }
      } catch (error) {
        toast.error(error.message);
      }
    };

    buscarEtapaAtual();
  }, []);

console.log(etapa)

  return (
    <Modal
      show={mostrarModal}
      onHide={() => setMostrarModal(false)}
      size={'xl'}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Pré-Venda: {linhaSelecionada.pre_venda}
          <span className="d-none d-sm-inline">
            {' '}
            - Proposta: {linhaSelecionada.codigo_proposta}
          </span>
          <span className="d-block d-sm-none">
            Proposta: {linhaSelecionada.codigo_proposta}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        <Row>
          <Col className="">
            <CardNavigationTab
              activeTab={tab}
              onChangeTab={verificaTab}
              tabs={[
                {
                  label: 'Detalhes da venda',
                  url: 'detalhes-pre-venda',
                  component: (
                    <DetalhesAtivo
                      linhaSelecionada={linhaSelecionada}
                      ativo={ativo}
                    />
                  ),
                },
                condicaoEspecial.condicoes && {
                  label: 'Condição especial',
                  url: 'condicaoEspecial',
                  component: (
                    <DetalhesCondicaoEspecial
                      condicoesEspeciais={condicaoEspecial}
                    />
                  ),
                },
                ocorrenciasVendaContraProposta && {
                  label: 'Contraproposta',
                  url: 'contraproposta',
                  component: (
                    <DetalhesContraproposta
                      infoContraproposta={ocorrenciasVendaContraProposta}
                    />
                  ),
                },
                {
                  label: 'Prospecto',
                  url: 'cliente-prospecto',
                  component: (
                    <ProspectoDetalhes
                      hiddenNavbar={true}
                      hiddenSearch={true}
                      showCancel={true}
                      prospectoID={linhaSelecionada.codigo_prospecto}
                    />
                  ),
                },

                habilitarCardEstorno() && {
                  label: 'Estorno',
                  url: 'estorno',
                  component: (
                    <DetalhesEstorno
                      proposta={linhaSelecionada.codigo_proposta}
                      ativo={ativo}
                      prospecto={linhaSelecionada}
                      corretorVenda={linhaSelecionada.codigo_corretor}
                      etapa={etapa}
                    />
                  ),
                },
                {
                  label: 'Manutenção Venda',
                  url: 'manutencao-venda',
                  component: (
                    <DetalhesManutencaoVenda
                      preVenda={linhaSelecionada.pre_venda}
                      codigoProposta={linhaSelecionada.codigo_proposta}
                      seq={linhaSelecionada.seq}
                      ge={linhaSelecionada.ge_cliente.split(' / ')[0]}
                    />
                  ),
                },
                podeAutorizarSemConjuge && {
                  label: 'Pré-Venda Sem Cônjuge',
                  url: 'preVenda-sem-conjuge',
                  component: (
                    <DetalhesPreVendaSemConjuge
                      preVenda={linhaSelecionada.pre_venda}
                    />
                  ),
                },
                podeSolicitarCancelamentoDocDigital && {
                  label: 'Cancelamento Contrato Digital',
                  url: 'Cancelamento-Contrato',
                  component: (
                    <DetalheCancelamentoDocDigital
                      codPreVenda={linhaSelecionada.pre_venda}
                    />
                  ),
                },
                {
                  label: 'Informações Jurídicas',
                  url: 'informacoes-juridicas',
                  component: (
                    <InformacoesJuridicas
                      cpf={linhaSelecionada.prospecto_cpf}
                    />
                  ),
                },
                // TODO: Descomentar quando o fluxo de cessão for para produção
                !isAmbienteProducao() && {
                  label: 'Visualizar Termo',
                  url: 'visualizar-termo',
                  component: (
                    <VisualizarTermo
                      preVenda={linhaSelecionada.pre_venda}
                    />
                  ),
                },
              ].filter(Boolean)}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <>
          <Button
            variant={'light'}
            type="submit"
            className="d-inline-flex align-items-center"
            onClick={() => {
              setMostrarModal(false);
            }}
          >
            <FaWindowClose />
            <span className="ml-2 d-xs-none">Fechar</span>
          </Button>
        </>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDetalhes;
